import { ProgramModel } from '@cibo/core'
import { useMemo } from 'react'
import { usePrograms } from '../queries'

export const useOpenPrograms = () => {
  const { data, ...rest } = usePrograms()

  const openPrograms = useMemo(
    () => (data || []).filter((program?: ProgramModel) => !!program && program.isOpenForEnrollment),
    [rest.dataUpdatedAt]
  )
  return { ...rest, openPrograms }
}
